import { render, staticRenderFns } from "./UnitsActivate.vue?vue&type=template&id=1544c3aa&"
import script from "./UnitsActivate.vue?vue&type=script&lang=js&"
export * from "./UnitsActivate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports